import React from "react";
import LoadingGIF from "../../assets/blue_loading.gif";

const Spinner: React.FC = () => (
  <div className="fixed inset-0 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg shadow-lg size-32 flex justify-center items-center">
      <img src={LoadingGIF} alt="로딩중" className="w-16 h-16" />
    </div>
  </div>
);

export default Spinner;
